import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-email',
  templateUrl: './icon-email.component.html',
  styles: []
})
export class IconEmailComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
